// ABC analysis of products by one metric (profit or revenue): articles are ranked by the metric;
// A — those that make up the first 80% of the total, B — the next 15%, C — the remaining 5%.
// An article belongs to a class by the cumulative share *before* it, so the article that crosses
// 80% is still A. Articles with a zero or negative value (loss, no sales) contribute nothing and
// are C. Articles without a value (profit unknown: no cost price) are left out and listed apart.
export const ABC_BOUNDS = { A: 80, B: 95 };
export const ABC_CLASSES = ['A', 'B', 'C'];

export function abcAnalysis(products, metric) {
  const known = [];
  const excluded = [];
  products.forEach((p) => {
    const v = p[metric];
    if (v === null || v === undefined || Number.isNaN(Number(v))) excluded.push(p);
    else known.push({ p, v: Number(v) });
  });
  known.sort((a, b) => b.v - a.v);
  const total = known.reduce((s, x) => s + Math.max(0, x.v), 0);

  let cumulative = 0;
  const rows = known.map(({ p, v }) => {
    const share = total > 0 && v > 0 ? (v / total) * 100 : 0;
    const before = cumulative;
    cumulative += share;
    let cls = 'C';
    if (v > 0 && total > 0) {
      if (before < ABC_BOUNDS.A) cls = 'A';
      else if (before < ABC_BOUNDS.B) cls = 'B';
    }
    return { ...p, abc: cls, abc_value: v, abc_share: share, abc_cumulative: Math.min(cumulative, 100) };
  });

  const summary = {};
  ABC_CLASSES.forEach((c) => { summary[c] = { count: 0, value: 0, share: 0, itemsShare: 0 }; });
  rows.forEach((r) => {
    const s = summary[r.abc];
    s.count += 1;
    s.value += r.abc_value;
    s.share += r.abc_share;
  });
  ABC_CLASSES.forEach((c) => { summary[c].itemsShare = rows.length ? (summary[c].count / rows.length) * 100 : 0; });
  return { rows, summary, excluded, total };
}
